export const adsenseSlots: { [prop: string]: string } = {
    PublicView_BelowTasks: "9442980567",
    PublicView_AsideTasks: "7206579906",
    PublicView_Top: "7699002443",

    "PublicTest_AboveTasks-Mobile": "7555339355",
    "PublicTest_BelowBreadcrumb-Mobile": "5400428237",

    Browse_Top: "2801813923",
    Browse_Filter_Bottom: "9882227595",
    Browse_Bottom: "6422221084",
    "Browser_Top-Mobile": "8773052254",
    Browse_Card: "2594808982",

    "Homework_Aside-Desktop": "5694530560",
    "Homework_Top-Mobile": "4511163600",
    "Homework_Middle-Mobile": "3198081937",
    "Homework_Bottom-Mobile": "4928243809",
    "Homework-Middle-Desktop": "8111497261",
    "Homework_Bottom-Desktop": "5854119141",

    // HomeworkCompletion_Top: "1466105977",
    // HomeworkCompletion_Bottom: "1250236132",
    "HomeworkCompleted_Aside-Desktop": "5338460852",
    // "HomeworkCompleted_Top-Mobile": "8151438407",

    "Homeworks_Top-Desktop": "5829501165",
    // "HomeworkResults_Aside-Desktop": "6516537507",
};

export const medianetSlots = {
    // PublicView_BelowTasks: {
    //     id: "882501134",
    //     size: "970x250",
    // },
    // PublicView_AsideTasks: {
    //     id: "883532365",
    //     size: "300x600",
    // },
    // PublicView_Top: {
    //     id: "292855227",
    //     size: "970x90",
    // },

    // "PublicTest_AboveTasks-Mobile": {
    //     id: "663614847",
    //     size: "320x50",
    // },
    // "PublicTest_BelowBreadcrumb-Mobile": {
    //     id: "418829393",
    //     size: "300x250",
    // },

    // Browse_Top: {
    //     id: "737649666",
    //     size: "728x90",
    // },
    // Browse_Filter_Bottom: {
    //     id: "684283244",
    //     size: "300x250",
    // },
    // Browse_Bottom: {
    //     id: "494781954",
    //     size: "970x90",
    // },
    // "Browser_Top-Mobile": {
    //     id: "157558816",
    //     size: "300x250",
    // },
    // Browse_Card_ad1: {
    //     id: "650510216",
    //     size: "300x250",
    // },
    // Browse_Card_ad2: {
    //     id: "377615103",
    //     size: "300x250",
    // },

    // "Homework_Aside-Desktop": {
    //     id: "118802608",
    //     size: "300x600"
    // },
    // "Homework_Top-Mobile": {
    //     id: "580266331",
    //     size: "300x50"
    // },
    // "Homework_Middle-Mobile": {
    //     id: "886781482",
    //     size: "300x50",
    // },
    // "Homework_Bottom-Mobile": {
    //     id: "823703332",
    //     size: "300x50",
    // },
    // "Homework-Middle-Desktop": {
    //     id: "116664423",
    //     size: "728x90",
    // },
    // "Homework_Bottom-Desktop": {
    //     id: "182862443",
    //     size: "970x250"
    // },

    // "HomeworkCompleted_Aside-Desktop": {
    //     id: "704180447",
    //     size: "970x250",
    // },

    // "Homeworks_Top-Desktop": {
    //     id: "856799715",
    //     size: "728x90",
    // }

}
